import { createI18n } from 'vue-i18n'
import fallbackMessages from '@/locales/it.json'
import apiClient from '@/api/client'

export type MessageSchema = typeof fallbackMessages

const i18n = createI18n({
  legacy: false,
  locale: 'it',
  fallbackLocale: 'it',
  messages: {
    it: fallbackMessages,
  },
})

/**
 * Fetch translations from backend and merge into vue-i18n.
 * Falls back silently to bundled locale file if the API is unreachable.
 */
export async function loadRemoteMessages(locale = 'it'): Promise<void> {
  try {
    const { data } = await apiClient.get<Record<string, string>>(`/static-text/locale/${locale}`)
    i18n.global.setLocaleMessage(locale, {
      ...fallbackMessages,
      ...data,
    })
  } catch {
    // Backend unreachable — keep bundled fallback
    console.warn(`[i18n] Could not load remote messages for "${locale}", using bundled fallback`)
  }
}

export default i18n
